export default {
    title: "Eestikeelne pealkiri",
    login: "Logi sisse",
    donate: "Anneta",
    joinUs: "Liitu aiaga",

    plant: {
        name: {
            label: "Taime nimi",
            uk: "Ukraina keeles",
            et: "Eesti keeles",
            en: "Inglise keeles",
            la: "Lastele"
        },

        latin: "Ladinakeelne taime nimi",
        description: {
            label: "Taime kirjeldused",
            uk: "Ukraina keeles",
            et: "Eesti keeles",
            en: "Inglise keeles",
            la: "Lastele"
        },
        pdf: {
            label: "Alla laetavad PDF dokumendid",
            uk: "Ukraina keeles",
            et: "Eesti keeles",
            en: "Inglise keeles",
            la: "Lastele"
        },

        audio: {
            label: "Kuulatavad heliklipid",
            uk: "Ukraina keeles",
            et: "Eesti keeles",
            en: "Inglise keeles",
            la: "Lastele"
        },

        image: "Taime pilt",
        author: "Teksti autor"
    },

    add_plant: "Lisa uus taim",
    edit_plant: "Muuda taime",
    save: "Salvesta",
    logout: "Logi välja",

    feedback: "Palun jagage oma mõtteid",
    send: "Saada",

    management: "Haldus",
    hildegard: "Hildegard",
    kogukonna_aed: "Kogukonna Aed",
    taimed: "Taimed",


    download: {
        label: "Lae alla PDF"
    }
}